const a = {
  id: "ArizonaFantasy5",
  name: "Fantasy 5",
  style: {
    colorPrimary: "#90bc37"
  }
};
export {
  a as default
};
